// 判断页面是否是rtl
import Config from '../../config';
export var getPlacement = function getPlacement(origPlacement, direction) {
  var isRtl = direction === 'rtl' || Config.getDirection() === 'rtl' || document.documentElement.getAttribute('dir') === 'rtl';
  var placement = origPlacement;

  if (isRtl) {
    if (placement === 'left') {
      placement = 'right';
    } else if (placement === 'right') {
      placement = 'left';
    } else if (placement === 'top-start') {
      placement = 'top-end';
    } else if (placement === 'top-end') {
      placement = 'top-start';
    } else if (placement === 'bottom-start') {
      placement = 'bottom-end';
    } else if (placement === 'bottom-end') {
      placement = 'bottom-start';
    } else if (placement === 'left-start') {
      placement = 'right-start';
    } else if (placement === 'right-start') {
      placement = 'left-start';
    } else if (placement === 'left-end') {
      placement = 'right-end';
    } else if (placement === 'right-end') {
      placement = 'left-end';
    }
  }

  return placement;
};